import { ComponentType } from '@modeso/types__aumico-lib-notes-be';

export interface NoteSelectionCard {
    imagePath: string;
    title: string;
    componentName: ComponentType;
    shouldBeVisibleForUser: boolean;
}
